/**
 * Decodes a JWT's payload and reports whether it's expired. Shared between
 * AuthContext (mount-time check) and usePortfolioStream (pre-connect check)
 * — previously duplicated in both, with a subtle mismatch: AuthContext's
 * copy treated a token with a missing/non-numeric `exp` claim as valid,
 * usePortfolioStream's treated it as expired. Consolidated on the latter,
 * deliberately: the backend always issues a proper `exp`, so this only
 * matters for a malformed/tampered token, and "unparseable or missing exp
 * ⇒ treat as expired" is the fail-safe direction — defaulting to logged-out
 * is the safe failure mode, not defaulting to forever-valid.
 */
export function isTokenExpired(jwt: string): boolean {
  try {
    const payload = JSON.parse(atob(jwt.split('.')[1]))
    return typeof payload.exp !== 'number' || payload.exp * 1000 < Date.now()
  } catch {
    return true
  }
}
